var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArchitectIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 34,
    viewBox: "0 0 26 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8441 0.0253906C12.4201 0.0253906 11.9898 0.0951147 11.5658 0.240901C9.49967 0.94765 8.39542 3.201 9.101 5.27054L17.9888 31.3188C18.5489 32.9637 20.0866 34 21.7319 34C22.1559 34 22.5862 33.9303 23.0102 33.7845C25.0763 33.0778 26.1806 30.8244 25.475 28.7549L16.584 2.70977C16.024 1.06174 14.4862 0.0253906 12.8441 0.0253906Z",
    fill: "#FFA233"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8411 0C11.1958 0 9.66125 1.03635 9.09804 2.68121L0.213381 28.7295C-0.492203 30.799 0.608888 33.0524 2.67818 33.7591C3.10216 33.9049 3.53247 33.9746 3.95646 33.9746C5.60176 33.9746 7.13633 32.9383 7.69953 31.2934L16.5842 5.24515C17.2898 3.17561 16.1887 0.922259 14.1194 0.215511C13.6954 0.0697241 13.2651 0 12.8411 0Z",
    fill: "#A22CC0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8441 0.0253906C12.4201 0.0253906 11.9898 0.0951147 11.5658 0.240901C9.49967 0.94765 8.39542 3.201 9.101 5.27054L12.8378 16.2236L16.584 5.24202C16.8466 4.46872 16.8593 3.67006 16.6631 2.93479L16.584 2.7066C16.024 1.06174 14.4862 0.0253906 12.8441 0.0253906Z",
    fill: "#DB2264"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.27221 24.2481H10.1009L12.803 16.325H7.27221C5.08901 16.325 3.31714 18.0997 3.31714 20.2865C3.31714 22.4733 5.08901 24.2481 7.27221 24.2481Z",
    fill: "#00EEC9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8726 16.325L15.5747 24.2481H18.4033C20.5865 24.2481 22.3584 22.4733 22.3584 20.2865C22.3584 18.0997 20.5865 16.325 18.4033 16.325H12.8726Z",
    fill: "#F73E2B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8029 16.325L10.1008 24.2481H15.5746L12.8725 16.325H12.8029Z",
    fill: "#00D9D5"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8377 7.10873C14.531 7.10873 15.9037 5.73378 15.9037 4.0377C15.9037 2.34162 14.531 0.966675 12.8377 0.966675C11.1444 0.966675 9.77173 2.34162 9.77173 4.0377C9.77173 5.73378 11.1444 7.10873 12.8377 7.10873Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4 23.3576C20.0932 23.3576 21.4659 21.9827 21.4659 20.2866C21.4659 18.5905 20.0932 17.2156 18.4 17.2156C16.7067 17.2156 15.334 18.5905 15.334 20.2866C15.334 21.9827 16.7067 23.3576 18.4 23.3576Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.18657 23.3576C8.87986 23.3576 10.2525 21.9827 10.2525 20.2866C10.2525 18.5905 8.87986 17.2156 7.18657 17.2156C5.49329 17.2156 4.12061 18.5905 4.12061 20.2866C4.12061 21.9827 5.49329 23.3576 7.18657 23.3576Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.94976 33.0904C5.64304 33.0904 7.01573 31.7155 7.01573 30.0194C7.01573 28.3233 5.64304 26.9484 3.94976 26.9484C2.25647 26.9484 0.883789 28.3233 0.883789 30.0194C0.883789 31.7155 2.25647 33.0904 3.94976 33.0904Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7508 33.0904C23.4441 33.0904 24.8168 31.7155 24.8168 30.0194C24.8168 28.3233 23.4441 26.9484 21.7508 26.9484C20.0575 26.9484 18.6848 28.3233 18.6848 30.0194C18.6848 31.7155 20.0575 33.0904 21.7508 33.0904Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchitectIcon);
export default __webpack_public_path__ + "static/media/architect-icon.86517035638d56a520b6f51feee6930d.svg";
export { ForwardRef as ReactComponent };